export function getDataGridStyles(theme, props) {
  const ui = theme.palette.ui;

  return {
    height: props.height ?? 650,
    width: '100%',

    '& .MuiDataGrid-columnHeader': {
      backgroundColor: ui.tableHeader,
    },

    '& .MuiDataGrid-headerFilterRow .MuiDataGrid-columnHeader': {
      backgroundColor: ui.dgFilterRow,
      paddingBottom: '5px',
    },

    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: ui.dgSelected,
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: ui.dgSelectedHover,
    },
    '& .MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: ui.tableRowEven,
    },
    '& .MuiDataGrid-row:nth-of-type(even):hover': {
      backgroundColor: ui.tableRowEvenHover,
    },
    '& .MuiDataGrid-row:nth-of-type(odd):hover': {
      backgroundColor: ui.tableRowOddHover,
    },
    '& .MuiDataGrid-row.Mui-selected:nth-of-type(even)': {
      backgroundColor: ui.dgSelectedEven,
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: ui.tableRowOdd,
    },
    '& .MuiDataGrid-row.Mui-selected:nth-of-type(odd)': {
      backgroundColor: ui.dgSelectedOdd,
    },
    '& .MuiDataGrid-row.Mui-selected:nth-of-type(odd):hover': {
      backgroundColor: ui.dgSelectedHover,
    },
    '& .MuiDataGrid-row.Mui-selected:nth-of-type(even):hover': {
      backgroundColor: ui.dgSelectedHover,
    },
    '& .MuiDataGrid-aggregationColumnHeaderLabel': {
      position: 'relative',
      marginTop: '4px',
    },
  };
}
